import React from 'react';

import { errorToDetails } from '../lib/errors';

export default function Loader({ label = 'Loading…' }) {
  return (
    <div className="ty-loader" role="status">
      <div className="ty-spinner" aria-hidden />
      <span>{label}</span>
    </div>
  );
}

/**
 * Inline error banner used by every page that fetches / submits data.
 *
 * Renders ALL backend errors — including DRF field-level validation maps
 * like `{ email: ["..."], password: ["..."] }` — as a tidy bullet list,
 * not the previous "[object Object]" stringification.
 *
 * Pass either an `Error` (axios or otherwise), a string, or `null`.
 */
export function ErrorBox({ error }) {
  if (!error) return null;
  const { title, status, method, url, lines, hideTrail } = errorToDetails(error);

  // The status / endpoint trail is invaluable when debugging; it's tiny
  // and visually de-emphasised so it doesn't dominate the message.
  const trail = hideTrail
    ? ''
    : [
        status ? `HTTP ${status}` : null,
        method && url ? `${method} ${url}` : (url || null),
      ].filter(Boolean).join(' • ');

  return (
    <div className="ty-error" role="alert">
      <div className="ty-error__head">
        <span aria-hidden className="ty-error__icon">⚠</span>
        <strong>{title}</strong>
      </div>

      {lines.length > 0 && (
        <ul className="ty-error__list">
          {lines.map((ln, i) => (
            <li key={i}>{ln}</li>
          ))}
        </ul>
      )}

      {trail && <div className="ty-error__trail">{trail}</div>}
    </div>
  );
}
